import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const SETTINGS_PERMISSIONS = {
  WRITE: PERMISSIONS.SETTINGS_WRITE,
};

export const SETTINGS_QUERY_KEYS = queryKeys.settings;
